import { render } from "./RolePermissionView.vue?vue&type=template&id=134b0b1e"
import script from "./RolePermissionView.vue?vue&type=script&lang=js"
export * from "./RolePermissionView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__